<template>
	<v-row>
		<v-col>
			<v-form v-model="formIsValid" ref="form" new-forms>

				<ui-box new-forms>
					<v-row>
						<v-col>
							<span>These will appear during checkout for a passholder to hear more from your organization.</span>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<sortable-multiple-select
									v-model="selectedMessageLists"
									class="message-lists"
									:items="messageLists"
									:lockedRows="internalMessageLists.length"
									selector-label="Add Message List"
									@input="setDirty"
							></sortable-multiple-select>
						</v-col>
					</v-row>
				</ui-box>
				<save-form
						:refs="$refs"
						:is-saving="isSaving"
						:is-valid="formIsValid"
						new-forms
						save-text="Save"
						@cancel-action="cancelChanges"
						@save-action="saveChanges"
				></save-form>
				<confirm-dialog
						description="Your changes have not been saved. Leaving now will discard them."
						:open="exitDialog"
						title="Unsaved Changes"
						@cancel="() => exitDialog = false"
						@confirm="doCancelChanges"
				></confirm-dialog>
			</v-form>
		</v-col>
	</v-row>
</template>

<script>
import ConfirmDialog from '@app/Shared/UI/ConfirmDialog.vue';

export default {
	name: 'ChannelMessageLists',
	components: {
		ConfirmDialog
	},
	props: {
		channel: {
			type: Object,
			default: () => ({})
		},
		partner: {
			type: Object | null,
			default: null
		},
		messageLists: {
			type: Array,
			default: () => []
		},
		returnUrl: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			formIsValid: false,
			exitDialog: false,
			isDirty: false,
			isSaving: false,
			selectedMessageLists: this.channel.r_message_lists?.map((item) => item.id) || [],
			internalMessageLists: this.channel.r_message_lists?.filter((item) => !item.is_external) || [],
		}
	},
	mounted() {
		this.setDefaultValues(this.channel);
	},
	methods: {
		cancelChanges() {
			if(this.isDirty) {
				this.exitDialog = true;
			}
			else {
				this.doCancelChanges();
			}
		},
		doCancelChanges() {
			window.location = this.getReturnUrl();
		},
		getReturnUrl() {
			return `/partner-portal/${this.partner.id}/channels/${this.channel.id}/settings`;
		},
		setDefaultValues(channel) {
			channel.messageLists = channel.messageLists || [];
		},
		setDirty() {
			this.isDirty = true;
		},
		saveChanges() {
			// Validate first...
			this.$refs.form.validate();
			if(!this.formIsValid) return;

			this.isSaving = true;
			//map selectedMessageLists to channel.messageLists with format id => idx
			this.channel.messageLists = this.selectedMessageLists.map((item, idx) => {
				return { message_list_id: item, sort_order: idx };
			});
			let url = `/partner-portal/${this.partner.id}/channels/save-channel/${this.channel.id || ''}`;
			axios.put(url, this.channel).then(response => {
				this.channel.id = response.data.channel.id;
				window.EventBus.$emit('system-messages', [
					{
						message: this.channel.name + ' ' + (this.channel.id
								? 'updated'
								: 'created') + ' - redirecting now...',
						messageType: 'success',
						showOverlay: true
					}
				]);
				setTimeout(() => {
					window.location = this.getReturnUrl();
				}, 2000);
			}).catch(error => {
				this.isSaving = false;
				window.EventBus.$emit('system-messages', [
					{ message: error.message, messageType: 'error' }
				]);
			});
		}
	}
};
</script>

<style lang="scss">
.message-lists {
	.v-list-item {
		padding: 0 0 !important;

		+ .v-list-item {
			border-top: solid 1px rgba(0, 0, 0, 0.096);
		}
	}
}
</style>
